import React, { FC, Fragment, useState } from 'react';
import { Button, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { lighten } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

import { ContentEmailSpec } from 'api';
import { useNotify } from 'hooks';
import { Loaders } from 'components';
import theme from 'theme';

import { PreviewDialog } from 'features/admin/components/ContentEmails';

const styles = {
  loaderButton: {
    position: 'relative',
  },
  preview: {
    padding: theme.spacing(1, 4),
    background: lighten(theme.palette.primary.main, 0.9),

    '&:hover': {
      background: theme.palette.primary.light,
    },
  },
} as const;

const FormActions: FC = () => {
  const { t } = useTranslation();
  const notify = useNotify();
  const navigate = useNavigate();

  const { dirty, isValid, isSubmitting, validateForm, submitForm, values } =
    useFormikContext<ContentEmailSpec>();

  const [open, setOpen] = useState(false);

  async function handlePreview() {
    const result = await validateForm();
    const hasErrors = !!Object.keys(result).length;

    if (hasErrors) {
      await submitForm();
      return notify.error({ i18n: { i18nKey: 'contentEmails:previewError' } });
    }

    setOpen(true);
  }

  return (
    <Fragment>
      <PreviewDialog open={open} onClose={() => setOpen(false)} values={values} />

      <Grid container alignItems="center" spacing={3} justifyContent="flex-end">
        <Grid>
          <Button variant="text" onClick={() => navigate(-1)}>
            {t('common:cancel')}
          </Button>
        </Grid>

        <Grid>
          <Button
            size="large"
            variant="text"
            color="primary"
            onClick={handlePreview}
            sx={styles.preview}
          >
            {t('common:preview')}
          </Button>
        </Grid>
        <Grid sx={styles.loaderButton}>
          <Button
            type="submit"
            size="large"
            color="primary"
            variant="contained"
            disabled={isSubmitting || !dirty || !isValid}
          >
            {t('contentEmails:saveEmail')}
          </Button>
          {isSubmitting && <Loaders.Button size={24} />}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default FormActions;
